import { render, staticRenderFns } from "./StatsOpenApi.vue?vue&type=template&id=3479f7da&scoped=true"
import script from "./StatsOpenApi.vue?vue&type=script&lang=js"
export * from "./StatsOpenApi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3479f7da",
  null
  
)

export default component.exports